import { DraftFullId } from "../Types/DraftFullId";

export function getClientDraftInfoUrl(draftId: DraftFullId) {
    // NOTE Эта функция объявлена отдельно, ибо она входит в состав client.js и
    // не должно происходить утежеления client.js-а
    return `v1/ns/${draftId.ns}/drafts/${draftId.draftId}/client-draft-info`;
}
